<template>
  <div class="banner" :style='bannerColor'>
    <!-- :style="setbannerStyle(globalConfig.head)" -->
    <div class="banner-content">
      <img class="banner-content_pic" 
        :src="bannerBg" 
        alt=""
      >
      <div class="button">
        <ul class="button_list">
          <template v-for="(item,index) in globalConfig.buttons">
             <li
              class="button_list_item"
              :key="index">
              <a
              :class="['button_list_item_link',{'cursor':item.link}]"
              :href="setButtonLink(item.link)"
              :style="setImgStyle(item.url)"></a>
              </li>
          </template>
        </ul>
      </div>
      <div class="banner-content_login">
        <div class="login_content" :style="viceColor">
          <div class="list">
            <ul class="list_ul">
              <li class="list_ul_item">
                <span :style="mainColor"></span>
                <i></i>
              </li>
              <li class="list_ul_item">
                <span :style="mainColor"></span>
                <i></i>
              </li>
              <li class="list_ul_item">
                <span :style="mainColor"></span>
                <i></i>
              </li>
              <li class="list_ul_item">
                <span :style="mainColor"></span>
                <i></i>
              </li>
            </ul>
          </div>
          <img 
            src="../assets/images/login-icon.png" 
            alt="" 
            width="78" 
            height="78" 
            v-if="loginType === 1"
          >
          <img 
            src="../assets/images/login-icon-outside.png" 
            alt="" 
            width="78" 
            height="78" 
            v-else
          >
          <p 
            class="logo_status" 
            :style="loginConfig" 
            v-if="!loginStatus">
            未登录
          </p>
          <template v-if='loginStatus'>
            <p 
              :class="['user_name',{'current_name':currentName === 'matchList' && loginStatus}]" 
              :style="loginConfig" 
              >
              {{userInfo.username || userInfo.realName}}
              <span 
                class='user_status_name' 
                v-if='handlerNameLen > 8 && currentName !== "matchList"'>
                ({{userState.innerText}})
              </span>
            </p>
            <p 
              :style="loginConfig"  
              v-if="handlerNameLen <= 8 && currentName !== 'matchList'" 
              class="user_status">
              ({{userState.innerText}})
            </p>
          </template>
          <div 
            :class="['button_hander',{'button_hander_reg':!isRegModel}]"
            v-show='!loginStatus || currentName !== "matchList"'
            >
            <!-- 登录 or 参赛进展 -->
            <button 
              v-if="!hideProcess"
              class="login_btn" 
              @click="loginBtn" 
              :style="btnConfig">
              {{userState.innerTextButton}}
            </button>
            <!-- 立即报名 -->
            <button 
              class="login_btn reg" 
              @click="regBtn" 
              :style="btnConfig" 
              v-if="isRegModel && Number(this.compType) !== 3">
              {{setRegText}}
            </button>
            <!-- 系列赛-注册入口 -->
            <!-- <button 
              class="login_btn reg" 
              @click="seriesBtn" 
              :style="[setStyle('main','backgroundColor'),setStyle('vice','color')]"
              v-if='!loginStatus && isSerial'
              >
              注册
            </button> -->
          </div>
         
        </div>
      </div>
    </div>
    <SignUpSuccess :dialogVisible.sync='dialogVisible'></SignUpSuccess>
  </div>
</template>
<script>
import { setColor, setBgImgStyle } from '../utils/style';
import { mapState,mapGetters,mapActions } from 'vuex'
import { getIsRegister,insideRegister } from '@/services/home'
import { getRegInfo,getProcessName } from '@/services/user';
import { errorHandler } from '@/utils/errorHandler';
import SignUpSuccess from './SignUpSuccess'
export default {
  name: 'headerBanner',
  props:{
    bannerImg:{
      type:String,
      default:''
    },
    main:{
      type:String,
      default:''
    },
    vice:{
      type:String,
      default:''
    },
    bgColor:{
      type:String,
      default:''
    },
    btnColor:{
      type:String,
      default:''
    },
    loginColor:{
      type:String,
      default:''
    },
  },
  data(){
    return{
      isInsideRegister: false,
      dialogVisible:false,
      timer:null,
      isRegModel:false,
      currentName:'',
      processName:'',
      registerStatus:0,
      regTextObj:{
        1:'报名未开始',
        2:'立即报名',
        3:'报名结束'
      },

    }
  },
  components:{
    SignUpSuccess
  },
  computed: {
    ...mapState({
      globalConfig: state => state.router.globalConfig,
      loginType:state => state.router.loginType,
      compType:state => state.router.compType,
      id: state => JSON.parse(state.router.id),
      userInfo: state => state.user.userInfo,
      websiteName:state => state.router.websiteName,
      isInsidSignUp:state => state.user.isInsidSignUp,
      isSerial:state=>state.router.isSerial
    }),
    ...mapGetters(['loginStatus']),
    setRegText(){
      let text = '';
      if(this.currentName !== 'matchList'){
        text = this.regTextObj[this.registerStatus]
      }
      if(this.currentName === 'matchList'){
        text = '注册'
      }
      if(this.registerStatus === 2){
        text = '立即报名'
        if(!this.loginStatus){
          if(this.isSerial || this.currentName === 'matchList') text = '注册'
        }
        if(this.loginStatus &&  this.isInsideRegister){
          if(this.loginType === 1 || this.isSerial) text = '已报名'
        }
      }
       return text;
    },
    bannerBg(){
      if(this.bannerImg) return this.bannerImg
      if(!this.globalConfig.head) return
      return `https://cdn.xiaohoucode.com/${this.globalConfig.head}`;
    },
    viceColor(){
      if(this.vice) return {
        'background-color':this.vice
      }
      return this.setStyle('vice','backgroundColor')
    },
    mainColor(){
      if(this.main) return {
        'background-color':this.main
      }
      return this.setStyle('main','backgroundColor')
    },
    bannerColor(){
      if(this.bgColor) return {
        'background-color':this.bgColor
      }
      return false
    },
    btnConfig(){
      if(this.btnColor && this.main) return{
        'background-color':this.main,
        'color':this.btnColor
      }
      return [
          this.setStyle('main','backgroundColor'),
          this.setStyle('vice','color')
      ]
    },
    loginConfig(){
      if(this.loginColor) return {
        'color':this.loginColor
      }
      return this.setStyle('main','color')
    },

    handlerNameLen(){
      if(this.loginType === 1) return this.userInfo.realName.length
      return this.userInfo.username.length
    },

     userState(){
      let innerText = '';
      let innerTextButton = '';
      if(!this.loginStatus) {
        innerText = '未登录';
        innerTextButton = '登录';
      }
      if(this.loginStatus){
        // 内部 + 未报名 || 未报名 + 系列赛
        if(this.loginType === 1 && !this.isInsideRegister || !this.isInsideRegister && this.isSerial){
          innerText = '未报名';
          innerTextButton = this.processName
                // 内部 + 已报名 || 外部
        }else if(this.loginType === 1 && this.isInsideRegister || this.loginType === 2){
          innerText = '已报名';
          innerTextButton = this.processName
        } 
      }
      return {
        innerText,
        innerTextButton
      }
    },
    hideProcess() {
      return Number(this.compType) === 3 && this.loginStatus
    }
    

  },
  watch:{
    loginStatus(newVal){
      if(newVal) this.getProcessName()
        
      if(newVal && this.loginType === 1 || newVal && this.isSerial) return this.isRegister()
      this.isInsideRegister = false;
    },
    isInsidSignUp:{
      handler() {
        if(this.loginStatus && this.loginType === 1 || this.loginStatus && this.isSerial){
          this.isRegister()
        }
      },
      immediate: true
    },
  },
  methods: {
    async getProcessName() {
      try {
        const { data } = await getProcessName({ competitionId: this.id });
        this.processName = data.processName;
        
      } catch (error) {
        errorHandler(error.data)
      }
    },

    async getRegModel(){
      try {
         const {status,data} = await getRegInfo(this.id)
         if(status === 200){
            this.isRegModel = true
            this.registerStatus = data.registerStatus;
         }
      } catch (error) {
        this.isRegModel = false
        const { status } = error;
        if(status === 404 && +this.compType === 3){
          return;
        }
        errorHandler(error.data)
      }
    },
    setButtonLink(link){
      let herf = link ? link : 'javascript:;'
      return herf;
    },
    ...mapActions(['setUserDiaLog','setRegDiaLog','setIsSerialDiaLog','setSerialType']),

    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
    setImgStyle(url) {
      if(!url) return
      return setBgImgStyle(url);
    },
    loginBtn(){
      if(!this.loginStatus) {
        this.setUserDiaLog({isShowDiaLog:true,currentVal:'login'})
        if(this.isSerial || this.currentName === 'matchList'){
          this.setIsSerialDiaLog(true)
        }
        return;
      }
      if(this.loginStatus) this.$router.push({
          path: '/cpFlow'
        })
    },
    regBtn(){

      // 未开始 || 已结束
      if([1,3].includes(this.registerStatus)) return;

      // 内部 + 已报名 + 已登录
      if(this.loginType === 1 && this.isInsideRegister && this.loginStatus) return;

      // 已报名 + 系列赛
      if(this.isInsideRegister && this.isSerial ) return;

      // 未登录 + 内部
      if(!this.loginStatus && this.loginType === 1){
        return this.setUserDiaLog({isShowDiaLog:true,currentVal:'login'});
      } 
      // 未登录 + 系列赛 || 系列赛列表页 =>注册
      if(!this.loginStatus && this.isSerial || this.currentName === 'matchList'){
        this.setIsSerialDiaLog(true);
        this.setUserDiaLog({isShowDiaLog:true,currentVal:'reg'});
        return
      }
      // 登录 + 系列赛 + 未报名 => 报名
      if(this.loginStatus && this.isSerial && !this.isInsideRegister){
        this.setSerialType('2')
        this.setUserDiaLog({isShowDiaLog:true,currentVal:'reg'});
        return;
      }

      this.setUserDiaLog({isShowDiaLog:true,currentVal:'reg'});
    },
    async isRegister(){
      let {status,data} = await getIsRegister(this.id);
      if(status === 200){
        this.isInsideRegister = data;
        this.$store.dispatch('setInsidSignUp', data)
      }
    },
    async insideRegister(){
      let {status} = await insideRegister(this.id);
      if(status === 200){
        this.isRegister()
        this.showSiginSuccessDialog()
      }
    },

    showSiginSuccessDialog(){
      this.dialogVisible = true;
    },
    receiveMessage(event) {
      try {
        let { data } = event;
        data = typeof data === 'string' ? JSON.parse(data) : data;
        const {
          type,
          ...payload
        } = data;

        if (typeof type === 'undefined') return;

        const method = type.replace(/_(\w)/g, (i, s) => s.toUpperCase());
        if (typeof this[method] === 'function') this[method](payload);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
      }
    },
  },
   mounted(){
    this.currentName = this.$route.name;
    if(this.loginStatus && this.loginType === 1 || this.loginStatus && this.isSerial){
      this.isRegister()
    }
    window.addEventListener('message', this.receiveMessage, false);
    if(this.currentName !== 'matchList'){
      this.getRegModel()
    }else{
      this.isRegModel = true
    }
    if(this.loginStatus) this.getProcessName()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage, false);
  },
};
</script>

<style lang='less' scoped>
.banner{
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  .banner-content{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content:center;
    .button{
      position: absolute;
      left:50%;
      transform: translate(-50%,0);
      bottom:78px;
      width: 494px;
      z-index: 1;
      .button_list{
        display: flex;
        padding: 0;
        margin: 0;
        .button_list_item{
          width: 150px;
          height: 38px;
          margin-right:20px;
          transition:all .1s ease;
          &:hover{
            transform: scale(1.1);
          }
          .button_list_item_link{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 20px;
            cursor: default;
            &.cursor{
              cursor: pointer;
            }
          }

        }
      }
    }
    .login_content{
      width: 226px;
      height: 270px;
      background-size:cover ;
      position: absolute;
      bottom:48px;
      left:-2px;
      text-align: center;
      padding-top:32px;
      box-sizing: border-box;
      box-shadow: 0px 0px 8px 0px rgba(76, 76, 76, 0.27);
      border-radius: 15px;
      .logo_status{
        padding: 0;
        margin: 0;
        padding:12px 0 12px;
        font-size: 16px;
      }
      .button_hander{
        width: 100%;
        height: 74px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-top:11px;
        box-sizing: border-box;
        &.button_hander_reg{
          justify-content: center;
        }
      }
      .login_btn{
        height: 32px;
        line-height: 32px;
        padding:0 30px;
        border:none;
        border-radius: 20px;
        font-size: 16px;
        font-weight: 500;
        outline: none;
        cursor: pointer;
        transition:all .1s ease;
        width: 150px;
        &:hover{
          transform:scale(1.1);
        }
      }
      .list{
        position: absolute;
        height: 100%;
        left:0;
        top:0;
        .list_ul{
          height:100%;
          padding: 0;
          margin: 0;
          list-style: none;
          display: flex;
          flex-direction: column;
          padding:48px 0;
          box-sizing: border-box;
          justify-content: space-between;
          .list_ul_item{
             position: relative;
             width: 40px;
             height: 10px;
            span{
              // position: absolute;
              // left:-10px;
              display: block;
              width: 40px;
              height: 10px;
              background: #fff;
              border-radius: 5px;
              margin-left:-15px;
              position: absolute;
              z-index: 1;
              box-shadow:inset 0px -2px 0px #DBDBDB,0px 2px 0px rgba(0, 0, 0, .3);
            }
             i{
                display: block;
                width: 14px;
                height: 14px;
                background: #232323;
                position: absolute;
                right:12px;
                top:-2px;
                border-radius: 50%;
              }
          }
        }
      }
      .user_name{
        font-size: 16px;
        font-weight: 500;
        width: 160px;
        margin: 10px auto 0;
        font-family: PingFangSC-Medium, PingFang SC;
        
      }
      .user_status{
        font-size: 14px;
        color:#333;
        margin: 0;
        padding: 0;
        margin-top:4px;
        font-weight: 500;
        &_name{
          font-size: 14px;
        }
      }
    }
    &_login{
      width: 1100px;
      height: 100%;
      position: absolute;
      top:0;
      left:50%;
      transform: translate(-50%,0);
    }
    &_pic{
      height: 100%;
    }
  }
  .xh_dialog{
    min-height: 200px;
  }
  .header_banner_xh-dialog{
    color:red;
    .xh_dialog-center{
      min-height: 200px;
    }
  }
}
</style>